module.exports = __webpack_public_path__ + "assets/img/d22db5fb42bcf710cb19bf1180f3edca.png";